<div class="custom-header">
    <span>System Stats</span>
    <i class="float-right fas clickable" [ngClass]="isCollapsed ? 'fa-chevron-circle-down' : 'fa-chevron-circle-up'" (click)="toggleStatTable()"></i>
</div>
<div class="queue-table table-responsive" [hidden]="isCollapsed">
    <table class="table table-sm table-borderless">
        <thead>
            <tr>
                <th>Machine Type</th>
                <th class="text-center"> Instance ID</th>
                <th class="text-center"> IP address</th>
                <th class="text-center"> Start Time</th>
                <th class="text-center">End time</th>
                <th class="text-center">Max.CPU Utilization</th>
                <th class="text-center"> Machine Status</th>
            </tr>
        </thead>
        <span *ngIf="!machineList || machineList.length === 0" class="text-right">No machines found for this execution</span>
        <tr *ngFor='let machine of machineList'>
            <td>{{machine.performanceInstanceType}}</td>
            <td class="text-center">{{machine.instanceId}}</td>
            <td class="text-center">{{machine.ipaddress}}</td>
            <td class="text-center">{{machine.startTime || '-'}}</td>
            <td class="text-center">{{machine.endTime || '-'}}</td>
            <td class="text-center">{{machine.maxCPUUsage || '-'}}</td>
            <td class="text-center">{{machine.instanceState || '-'}}</td>
        </tr>
    </table>
</div>